// this is an autogenerated file from App/Account/Content/Settings/Content/Procedures/Content/Content/Procedure/mutation-delete.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_Procedures_Content_Content_Procedure($id: numeric!) {
  delete_vaxiom_procedure_misc_fee_charge_templates(
    where: { procedure_id: { _eq: $id } }
  ) {
    affected_rows
  }
  delete_vaxiom_procedure_steps(where: { procedure_id: { _eq: $id } }) {
    affected_rows
  }
  delete_vaxiom_procedures_by_pk(id: $id) {
    id
  }
}

`